import {useSelector} from 'react-redux';
import Selector from '../../../../../selectors/pages/vip20/top/benefits';

import Freeplay from './freeplay';
import WeeklyRakeback from './weekly-rakeback';
import MonthlyRakeback from './monthly-rakeback';
import DepositAssistToken from './deposit-assist-token';
import BirthdayBonus from './birthday-bonus';
import RandomBoost from './random-boost';

import {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import Levels from './levels';

export default () => {
    const [isSlider, setSliderState] = useState(false),
          [swiper, setSwiper] = useState(null),
          {level} = useSelector(Selector);

    const resizeHandler = () => {
        let slider_state = document.body.offsetWidth > 1000 ? true : false;
        if(isSlider != slider_state) {
            console.log(swiper);
            setSliderState(slider_state);
        }
    }

    useEffect(() => {
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, [isSlider]);

    // if(level === "elite")
    //     return <></>;

    return (
        <div className="vip-20-benefits">
            <div className="vip-20-benefits-top">
                <div className="vip-20-benefits-title">
                    {level === "elite" ? "Your benefits " : "Unlock at "}
                    {level === "regular" ? (
                        <div className="vip-20-benefits-title-level bronze">
                            <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-bronze.png`} alt="Level Icon" />
                            Bronze
                        </div>
                    ) : <></>}

                    {level === "bronze" ? (
                        <div className="vip-20-benefits-title-level silver">
                            <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-silver.png`} alt="Level Icon" />
                            Silver
                        </div>
                    ) : <></>}

                    {level === "silver" ? (
                        <div className="vip-20-benefits-title-level gold">
                            <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-gold.png`} alt="Level Icon" />
                            Gold
                        </div>
                    ) : <></>}

                    {level === "gold" ? (
                        <div className="vip-20-benefits-title-level platinum">
                            <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-platinum.png`} alt="Level Icon" />
                            Platinum
                        </div>
                    ) : <></>}

                    {level === "platinum" ? (
                        <div className="vip-20-benefits-title-level diamond">
                            <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-diamond.png`} alt="Level Icon" />
                            Diamond
                        </div>
                    ) : <></>}

                    {level === "diamond" ? (
                        <div className="vip-20-benefits-title-level elite">
                            <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-elite.png`} alt="Level Icon" />
                            Elite
                        </div> 
                    ) : <></>}

                    {level === "elite" ? (
                        <div className="vip-20-benefits-title-level elite">
                            <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-elite.png`} alt="Level Icon" />
                            Elite
                        </div> 
                    ) : <></>}
                </div>

                <div className="vip-20-benefits-arrows">
                    <div className="arrow" onClick={e => {
                        if(swiper)
                            swiper.slidePrev();
                    }}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.5">
                                <path d="M9.99998 13.28L5.65331 8.9333C5.13998 8.41997 5.13998 7.57997 5.65331 7.06664L9.99998 2.71997" stroke="#DFDFEC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                        </svg>
                    </div>

                    <div className="arrow" onClick={e => {
                        if(swiper)
                            swiper.slideNext();
                    }}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.5">
                                <path d="M5.93994 13.28L10.2866 8.9333C10.7999 8.41997 10.7999 7.57997 10.2866 7.06664L5.93994 2.71997" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>

            <div className="vip-20-benefits-list">
                {isSlider ? (
                    <Swiper
                        modules={[]}
                        loop={true}
                        noSwiping={false}
                        speed={1e3}
                        slidesPerGroup={2}
                        slidesPerView={2}
                        spaceBetween={10}
                        onSwiper={(_swiper) => {
                            setSwiper(_swiper)
                        }}
                    >
                        {Levels[level].map(benefit => {
                            if(benefit.type === "freeplay") return  <SwiperSlide><Freeplay from={benefit.from} to={benefit.to} /></SwiperSlide>
                            if(benefit.type === "random_boost") return  <SwiperSlide><RandomBoost from={benefit.from} to={benefit.to} /></SwiperSlide>
                            if(benefit.type === "weekly_rakeback") return  <SwiperSlide><WeeklyRakeback from={benefit.from} to={benefit.to} /></SwiperSlide>
                            if(benefit.type === "monthly_rakeback") return  <SwiperSlide><MonthlyRakeback from={benefit.from} to={benefit.to} /></SwiperSlide>
                            if(benefit.type === "birthday_bonus") return  <SwiperSlide><BirthdayBonus from={benefit.from} to={benefit.to} /></SwiperSlide>
                            if(benefit.type === "deposit_assist_token") return  <SwiperSlide><DepositAssistToken from={benefit.from} to={benefit.to} /></SwiperSlide>
                            return <></>;
                        })}
                    </Swiper>
                ) : (
                    <div className="vip-20-benefits-list-line">
                        {Levels[level].map(benefit => {
                            if(benefit.type === "freeplay") return  <Freeplay from={benefit.from} to={benefit.to} />;
                            if(benefit.type === "random_boost") return <RandomBoost from={benefit.from} to={benefit.to} />;
                            if(benefit.type === "weekly_rakeback") return  <WeeklyRakeback from={benefit.from} to={benefit.to} />;
                            if(benefit.type === "monthly_rakeback") return  <MonthlyRakeback from={benefit.from} to={benefit.to} />;
                            if(benefit.type === "birthday_bonus") return  <BirthdayBonus from={benefit.from} to={benefit.to} />;
                            if(benefit.type === "deposit_assist_token") return  <DepositAssistToken from={benefit.from} to={benefit.to} />;
                            return <></>;
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}